export default function getUsersReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_USER_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_USER_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_USER_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}